<template>
  <v-container fluid>
    <v-row align="center" class="mt-n2 mb-2" dense>
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete v-model="form.clientId" :items="farms" :loading="fetchingFarms" :search-input.sync="searchFarm"
          item-value="_id" :item-text="getFarmText" label="Agrícola" placeholder="Nombre o razón social"
          prepend-inner-icon="mdi-magnify" clearable return-object hide-details no-filter outlined dense
          no-data-text="No se encontraron agrícolas" class="white rounded-lg">
          <!-- ... template slots same ... -->
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>
                {{ data.item.billingInformation && data.item.billingInformation.companyName ?
                  data.item.billingInformation.companyName : 'Sin razón social' }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ data.item.companyName }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-text-field prepend-inner-icon="mdi-magnify" v-model="search" clearable label="Buscar muestras..."
          hide-details outlined dense class="white rounded-lg">
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="12" md="4" class="text-end d-flex justify-end align-center">
        <v-dialog
          v-model="filterDialog"
          width="500"
          :fullscreen="$vuetify.breakpoint.xsOnly"
          transition="dialog-bottom-transition"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="secondary" v-bind="attrs" v-on="on" rounded small elevation="0" class="mr-2">
              <v-icon left size="18">mdi-filter-multiple</v-icon> Filtros
            </v-btn>
          </template>

          <v-card :height="$vuetify.breakpoint.xsOnly ? '100%' : 'auto'">
            <v-card-title class="headline primary white--text">
              Filtros
              <v-spacer></v-spacer>
              <v-btn icon dark @click="filterDialog = false" v-if="$vuetify.breakpoint.xsOnly">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col>
                    <span> Cultivo </span>
                    <v-autocomplete v-model="form.cropCycle" :items="crop_items" label="Seleccione un cultivo"
                      no-data-text="No hay cultivo" solo dense clearable></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Tipò de muestra </span>
                    <v-autocomplete v-model="form.sampleType" :items="sampleType" label="Seleccione tipo de muestra"
                      solo no-data-text="No hay cultivo" dense clearable></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Tipo de análisis </span>
                    <v-autocomplete v-model="form.analysisType" :items="analysisType"
                      label="Seleccione tipo de análisis" no-data-text="No hay cultivo" solo dense
                      clearable></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <span> Estatus muestra </span>
                    <v-autocomplete v-model="form.sampleStatus" :items="sampleStatus"
                      label="Seleccione estatus de muestra" no-data-text="No hay estatus" solo dense
                      clearable></v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="gray" dark @click="filterDialog = false">
                Cancelar
              </v-btn>
              <v-btn color="info" @click="cleanFilters">
                Limpiar filtros
              </v-btn>
              <v-btn color="primary" @click="applyFilters"> Aplicar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn color="primary" rounded small class="mr-2" @click="fetchData" elevation="0" :icon="$vuetify.breakpoint.xsOnly">
          <v-icon :left="!$vuetify.breakpoint.xsOnly"> mdi-refresh </v-icon>
          <span v-if="!$vuetify.breakpoint.xsOnly">Refrescar</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="mt-n4">
      <v-col>
        <v-data-table width="100%" :height="$vuetify.breakpoint.smAndDown ? 'auto' : `calc(100vh - 350px)`" :headers="headers" :items="samples" fixed-header :items-per-page="10"
          no-data-text="No hay muestras en transito" loading-text="Cargando muestras en transito..." :page.sync="page"
          hide-default-footer :loading="fetchingData">
          <template #[`item.sampling_status`]="{ item }">
            <v-chip v-if="item.sampling_status == 'VALIDATED'" color="#dadada">
              {{ getStatus(item.sampling_status) }}
            </v-chip>
            <v-chip v-else color="info" text-color="black">
              {{ getStatus(item.sampling_status) }}
            </v-chip>
          </template>
          <template #[`item.crop`]="{ item }">
            <v-icon v-if="item.crop" color="primary">mdi-sprout-outline</v-icon>
            <v-icon v-else color="gray">mdi-sprout-outline</v-icon>
            {{ getCrop(item.crop) }}
          </template>

          <template #[`item.field_registration`]="{ item }">
            {{ getDateFormatted(item.field_registration) }}
          </template>
          <template #[`item.sample_type`]="{ item }">
            {{ getSampleType(item.sample_type) }}
          </template>
          <template #[`item.analysis_type`]="{ item }">
            {{ getAnalysisType(item.analysis_type) }}
          </template>
          <template #[`item.qr_code`]="{ item }">
            <v-icon color="primary" @click="openSampleDetail(item._id)">mdi-qrcode</v-icon>
            {{ item.qr_code }}
          </template>
          <template #[`item.guide`]="{ item }">
            <v-icon @click="openGuideModel(item.guide)">
              mdi-map-marker-path
            </v-icon>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="numPages" total-visible="10" color="primary" class="mt-n2"></v-pagination>
      </v-col>
    </v-row>
    <v-row class="text-center" v-if="showFetchingDataButton">
      <v-col>
        <v-btn color="primary" rounded @click="fetchData"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-col>
    </v-row>
    <GuideModal v-model="showGuideModal" v-if="showGuideModal" />
    <DetailSample v-model="showDetailSample" v-if="showDetailSample" />
  </v-container>
</template>

<script>
//Vuex
import { mapActions, mapState, mapMutations } from "vuex";
//Libraries
import dayjs from "dayjs";
//axios
import axios from "axios";
//components
import GuideModal from "@/components/reception/modals/GuideModal";
import DetailSample from "@/components/reception/modals/DetailSample";
export default {
  components: {
    GuideModal,
    DetailSample,
  },
  data: () => ({

    samples: [],
    fetchingData: false,
    page: 1,
    numPages: 0,
    search: null,
    showFetchingDataButton: false,
    filterDialog: false,
    crop_items: [],
    sampleType: [
      {
        text: "Suelo compuesto",
        value: "CLASSIC",
      },
      {
        text: "Vegetal",
        value: "MAS_VEGETABLE",
      },
      {
        text: "Vegetal sin georeferencia",
        value: "VEGETABLE",
      },
      {
        text: "Composta",
        value: "COMPOST",
      },
      {
        text: "Producto",
        value: "PRODUCT",
      },
      {
        text: "Sustrato",
        value: "SUBSTRATUM",
      },
      {
        text: "Suelo sin asesor",
        value: "NO_ADVISOR",
      },
      {
        text: "Suelo compuesto",
        value: "CLASSIC",
      },
    ],
    analysisType: [
      {
        text: "Inicial",
        value: "INITIAL",
      },
      {
        text: "Seguimiento",
        value: "MONITORING",
      },
    ],
    sampleStatus: [
      {
        text: "Muestreada",
        value: "VALIDATED",
      },
      {
        text: "Muestreo en progreso",
        value: "IN_PROGRESS",
      },
    ],
    form: {
      cropCycle: null,
      sampleType: null,
      analysisType: null,
      sampleStatus: null,
      clientId: null,
    },
    farms: [],
    fetchingFarms: false,
    searchFarm: null,
    showGuideModal: false,
    showDetailSample: false,
    user: JSON.parse(localStorage.getItem("user")),
  }),
  async mounted() {
    // this.page = parseInt(this.$route.params.page, 10);
    this.setCropItems();
    await this.fetchData();
  },
  computed: {
    ...mapState("reception", ["crops"]),
    ...mapState(["cancelToken"]),
    headers() {
      const isMobile = this.$vuetify.breakpoint.xsOnly;
      const allHeaders = [
        { text: "QR container", value: "qr_code", sortable: false },
        { text: "Tipo de análisis", value: "analysis_type", sortable: false },
        { text: "Tipo de muestra", value: "sample_type", sortable: false },
        { text: "#SM", value: "qty_sub_sample", sortable: false },
        { text: "Unidad de riego", value: "irrigation_unit_name", sortable: false },
        { text: "Cultivo", value: "crop", sortable: false },
        { text: "Productor", value: "client_name", sortable: false },
        { text: "Responsable", value: "sampler_name", sortable: false },
        { text: "Registro en campo", value: "field_registration", sortable: false },
        { text: "Guía", value: "guide", sortable: false },
        { text: "Estatus del muestreo", value: "sampling_status", sortable: false },
      ];

      if (isMobile) {
        return allHeaders.filter(h => ["qr_code", "client_name", "sampling_status"].includes(h.value));
      }
      return allHeaders;
    },
  },
  methods: {
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    ...mapActions("reception", ["getTransitSampleAdmin"]),
    ...mapActions("organization", ["getFarms"]),
    ...mapMutations("reception", [
      "SET_GUIDE",
      "CAN_UPDATE_GUIDE",
      "SET_SAMPLE",
    ]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    async fetchData() {
      this.fetchingData = true;
      try {
        if (typeof this.cancelToken != "undefined") {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }
        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());
        let payload = {
          page: this.page,
          search: this.search,
          // laboratory: this.user.laboratory._id,
          filters: this.form,
          clientId: this.form.clientId ? this.form.clientId._id : null,
        };
        let response = await this.getTransitSampleAdmin(payload);
        if (response) {
          if (!response.error) {
            //hide loaders
            this.fetchingData = false;
            this.showFetchingDataButton = false;
            //set sample data
            this.samples = response.samples;
            this.numPages = response.pages;
          } else {
            throw response;
          }
        }
      } catch (e) {
        this.fetchingData = false;
        if (axios.isCancel(e)) {
          console.log("Request canceled", e.message);
          return;
        }
        //print log
        console.log(e);
        //hide loaders
        this.fetchingData = false;
        //show attempt button to try fetch data manually
        this.showFetchingDataButton = true;
        //show error to user
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: "Algo salio mal cargar muestras en transito, intente de nuevo !!",
          timeout: 5000,
        });
      }
    },
    getStatus(value) {
      let status = {
        IN_PROGRESS: "En proceso",
        VALIDATED: "Finalizado",
      };
      return status[value];
    },
    setCropItems() {
      let cropsArray = Object.entries(this.crops);
      for (let crop of cropsArray) {
        this.crop_items.push({
          text: crop[1],
          value: crop[0],
        });
      }
    },
    getCrop(value) {
      let template = "";
      const crop = {
        olive: "Aceituna",
        chard: "Acelga",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Aguacate",
        garlic: "Ajo",
        sesame: "Ajonjolí",
        basil: "Albahaca",
        artichoke: "Alcachofa",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Alfalfa achicalada",
        greenAlfalfa: "Alfalfa verde",
        cotton: "Algodón",
        almond: "Almendro",
        birdseed: "Alpiste",
        amaranth: "Amaranto",
        anise: "Anís",
        celery: "Apio",
        blueberry: "Arándano",
        myrtle: "Arrayán",
        rice: "Arroz",
        greenForageOats: "Avena forrajera en verde",
        oatGrain: "Avena grano",
        bamboo: "Bambú",
        eggplant: "Berenjena",
        beetroot: "Betabel",
        broccoli: "Brocoli",
        peanut: "Cacahuate",
        cocoa: "Cacao",
        cherryCoffee: "Café cereza",
        pumpkin: "Calabaza",
        sweetPotato: "Camote",
        sugarCane: "Caña de azúcar",
        canola: "Canola",
        carambolo: "Carambolo",
        safflower: "Cártamo",
        barley: "Cebada",
        greenForageBarley: "Cebada forrajera en verde",
        onion: "Cebolla",
        chives: "Cebollín",
        ryeGrain: "Centeno grano",
        cherry: "Cereza",
        chabacano: "Chabacano",
        pea: "Chícharo",
        squash: "Chayote",
        chia: "Chía",
        chilacayote: "Chilacayote",
        chillyPepper: "Chile / Pimiento",
        custardApple: "Chirimoya",
        coriander: "Cilantro",
        plum: "Ciruela",
        coconutFruit: "Coco fruta",
        cabbage: "Col (repollo)",
        brusselsSprouts: "Col de Bruselas",
        cauliflower: "Coliflor",
        cumin: "Comino",
        chrysanthemum: "Crisantemo (planta)",
        peach: "Durazno",
        date: "Dátil",
        greenBean: "Ejote",
        cornCob: "Elote",
        dill: "Eneldo",
        epazote: "Epazote",
        asparagus: "Espárrago",
        spicesAndMedicinals: "Especias y medicinales",
        spinach: "Espinaca",
        raspberry: "Frambuesa",
        strawberry: "Fresa",
        bean: "Frijol",
        chickpea: "Garbanzo",
        sunflower: "Girasol",
        pomegranate: "Granada",
        soursop: "Guanábana",
        guava: "Guayaba",
        henequen: "Henequén",
        peppermint: "Hierbabuena",
        aromaticHerbs: "Hierbas aromáticas",
        fig: "Higo",
        jamaica: "Jamaica",
        ginger: "Jenjibre",
        jicama: "Jícama",
        lettuce: "Lechuga",
        lentil: "Lenteja",
        lime: "Lima",
        lemon: "Limón",
        linseed: "Linaza",
        litchi: "Litchi",
        corn: "Maíz",
        macadamia: "Macadamia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Mandarina",
        mango: "Mango",
        mangosteen: "Mangostán",
        chamomile: "Manzanilla",
        appleTree: "Manzano",
        passionFruit: "Maracuyá",
        daisyFlower: "Margarita",
        marjoram: "Mejorana",
        melon: "Melón",
        quince: "Membrillo",
        mint: "Menta",
        moringa: "Moringa",
        turnip: "Nabo",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Naranja",
        medlar: "Níspero",
        nochebuena: "Nochebuena (planta)",
        walnut: "Nogal",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Orégano",
        ornamental: "Ornamentales",
        orchid: "Orquídea (planta)",
        oilPalm: "Palma africana o de aceite",
        potato: "Papa",
        papaya: "Papaya",
        grasslands: "Pastizales",
        matGrass: "Pasto tapete (m2)",
        pasturesAndMeadows: "Pastos y praderas",
        cucumber: "Pepino",
        pearTree: "Peral",
        parsley: "Perejil",
        peron: "Perón",
        persimony: "Persimonio",
        pepper: "Pimienta",
        pineapple: "Piña",
        pinion: "Piñón",
        pistache: "Pistache",
        pitaya: "Pitaya",
        banana: "Plátano",
        pore: "Poro",
        radish: "Rábano",
        rambutan: "Rambután",
        romerito: "Romerito",
        rosemary: "Romero",
        aloe: "Sábila",
        watermelon: "Sandía",
        sorghum: "Sorgo",
        soy: "Soya",
        stevia: "Stevia",
        tobacco: "Tabaco",
        tamarind: "Tamarindo",
        tejocote: "Tejocote",
        tomato: "Tomate Rojo (jitomate)",
        greenTomato: "Tomate Verde",
        thyme: "Tomillo",
        grapefruit: "Toronja (pomelo)",
        clover: "Trébol",
        wheat: "Trigo",
        dutchTulip: "Tulipán holandés",
        tuna: "Tuna",
        grape: "Uva",
        vanilla: "Vainilla",
        purslane: "Verdolaga",
        vine: "Vid",
        cassavaFood: "Yuca alimenticia",
        carrot: "Zanahoria",
        sapodilla: "Zapote",
        blackberry: "Zarzamora",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Barbecho",
        other: "Otro",
      };
      let cropName = crop[value];
      if (cropName) {
        template = cropName;
      } else {
        template = "Sin cultivo";
      }
      return template;
    },
    getDateFormatted(value) {
      const date = `${dayjs(value).format("D/M/YYYY - HH:mm")} hrs`;
      return date ? date : "----";
    },
    getSampleType(value) {
      const types = {
        CLASSIC: "Suelo compuesto",
        MAS: "Muestra para genómica",
        MAS_VEGETABLE: "Vegetal",
        VEGETABLE: "Vegetal sin georeferencia",
        COMPOST: "Composta",
        PRODUCT: "Producto",
        SUBSTRATUM: "Sustrato",
        NO_ADVISOR: "Suelo sin asesor",
      };
      if (value.type) {
        let temp = types[value.type];
        if (value.type == "COMPOST" || value.type == "PRODUCT") {
          if (value.composition) {
            let compositions = {
              LIQUID: "Líquido",
              SOLID: "Sólido",
            };
            temp += ` ${compositions[value.composition]}`;
          }
        }
        return temp;
      } else {
        return "N/A";
      }
    },
    getAnalysisType(value) {
      if (value == "INITIAL" || value == "Initial") {
        return "Inicial";
      } else {
        return "Seguimiento";
      }
    },
    async fetchFarms(val) {
      if (!val || val.length < 2) return;
      this.fetchingFarms = true;
      try {
        let payload = {
          search: val,
          page: 1,
        };
        let response = await this.getFarms(payload);
        if (response && !response.error) {
          this.farms = response.famrs;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.fetchingFarms = false;
      }
    },
    getFarmText(item) {
      if (!item) return "";
      let billing =
        item.billingInformation && item.billingInformation.companyName
          ? item.billingInformation.companyName
          : "";
      let company = item.companyName || "";
      if (billing && company) return `${billing} - ${company}`;
      return billing || company || "N/A";
    },
    async applyFilters() {
      this.filterDialog = false;
      this.page = 1;
      await this.fetchData();
    },
    async cleanFilters() {
      this.search = null;
      this.filterDialog = false;
      this.form = {
        cropCycle: null,
        sampleType: null,
        analysisType: null,
      };
      await this.fetchData();
    },
    openGuideModel(value) {
      this.CAN_UPDATE_GUIDE(false);
      this.SET_GUIDE(value);
      this.showGuideModal = true;
    },
    openSampleDetail(value) {
      this.SET_SAMPLE(value);
      this.showDetailSample = true;
    },
  },
  watch: {
    async search() {
      this.page = 1;
      await this.fetchData();
    },
    async searchFarm(val) {
      if (!val) return;
      // Evitar buscar si el valor es el mismo que el seleccionado actualmente
      if (this.form.clientId) {
        const selectedText = this.getFarmText(this.form.clientId);
        if (val === selectedText) return;
      }
      await this.fetchFarms(val);
    },
    "form.clientId": {
      async handler() {
        this.page = 1;
        await this.fetchData();
      },
      deep: true,
    },
    async page() {
      // if (this.page != parseInt(this.$route.params.page)) {
      //   this.$router.replace({
      //     params: {
      //       page: this.page,
      //     },
      //   });
      // }
      await this.fetchData();
    },
  },
};
</script>

<style scoped></style>
